import { useMutation } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../CommonUtils/httpBodyOptions';

interface SwitchClientAssociatedProfilesResponseDTO {
  redirectUrl: string;
}

const mutateClientAssociatedProfiles = async ({
  userDetailId,
  clientId,
}: {
  userDetailId: number;
  clientId: string;
}): Promise<SwitchClientAssociatedProfilesResponseDTO> =>
  authFetch('/Consumer/ClientAssociatedProfiles/switch', {
    method: 'POST',
    ...httpBodyOptions({ userDetailId, clientId }),
  });

export const useClientAssociatedProfilesMutation = () => {
  return useMutation(mutateClientAssociatedProfiles);
};
